exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".not-found {\n  text-align: center; }\n  .not-found .img-responsive {\n    display: inline-block; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./modules/base/css/404.scss
// module id = 515
// module chunks = 0